module.exports = require("TweenLite");;